<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年03月13日 10:18:19 +0800
 * @最后修改时间: 2022-03-07 14:18:04
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Claim\ClaimReason\viewClaimReason.vue
 -->
<template>
  <ContentLayout
    :title="
      iSEdited
        ? $t('label_essweb_ClaimReason_form_editTitle')
        : $t('label_essweb_ClaimReason_form_viewTitle')
    "
    widthClass="max-1000"
    backgroundClass="white"
    :editBtn="!iSEdited && hasBtn('edit-admin-claim-reason')"
    :initData="ClaimReasonData"
    @change="(changed) => (isChanged = changed)"
    :checkData="[
      'claim_reason_name',
      'sequence',
      'claim_reason_description',
      'claim_reason_code',
      'claim_type_uuid',
      'remarks',
    ]"
    :delBtn="hasBtn('delete-admin-claim-reason')"
    @delete="
      $confirmDo($t('label_essweb_ClaimReason_list_title')).then((res) => {
        res ? toDelete() : null;
      })
    "
    @edit="iSEdited = true"
  >
    <!-- content -->
    <template v-slot:page-main>
      <v-form ref="form" lazy-validation>
        <v-row>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <inputTextFiledMultiLang
              :filled="iSEdited"
              :readonly="!iSEdited"
              :bindData="ClaimReasonData.claim_reason_name"
              @change="
                (valueArr) => {
                  ClaimReasonData.claim_reason_name = valueArr;
                }
              "
              :label="$t('label_essweb_ClaimReason_form_claimReasonNameLabel')"
              :rules="$GetRules(['_Require_Rules'], [null])"
            />
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-sheet class="mrc_text_require text--secondary">{{
              $t("label_essweb_ClaimReason_form_claimTypeLabel")
            }}</v-sheet>
            <v-autocomplete
              :filled="iSEdited"
              :readonly="!iSEdited"
              :items="ClaimType"
              item-text="claim_type_name"
              item-value="uuid"
              v-model="ClaimReasonData.claim_type_uuid"
              :append-icon="iSEdited ? 'arrow_drop_down' : ''"
              single-line
              :rules="$GetRules(['_Require_Rules'], [null])"
              :placeholder="$t('label_essweb_ClaimReason_form_claimTypeLabel')"
              dense
            >
              <template v-slot:no-data> <noContent /> </template
            ></v-autocomplete>
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <normalInputTextFiled
              :filled="iSEdited"
              :readonly="!iSEdited"
              v-model="ClaimReasonData.claim_reason_code"
              maxlength="100"
              :rules="
                $GetRules(['_Require_Rules', '_Length_Rules'], [null, 100])
              "
              :label="$t('label_essweb_ClaimReason_form_codeLabel')"
            />
          </v-col>
          <v-col :md="iSEdited ? 3 : 6">
            <numberInputTextFiled
              :filled="iSEdited"
              :readonly="!iSEdited"
              v-model="ClaimReasonData.sequence"
              :rules="$GetRules(['_Number_negative'], [null])"
              :label="$t('label_essweb_ClaimReason_form_sequenceLabel')"
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <inputTextFiledMultiLang
              :filled="iSEdited"
              :readonly="!iSEdited"
              :bindData="ClaimReasonData.claim_reason_description"
              @change="
                (valueArr) => {
                  ClaimReasonData.claim_reason_description = valueArr;
                }
              "
              :label="$t('label_essweb_ClaimReason_form_descriptioneLabel')"
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_ClaimReason_form_remarkLabel")
            }}</v-sheet>
            <v-textarea
              rows="5"
              no-resize
              maxlength="500"
              :filled="iSEdited"
              :readonly="!iSEdited"
              counter="500"
              dense
              single-line
              v-model="ClaimReasonData.remarks"
              name="input-7-4"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-form>
    </template>
    <!-- content -->
    <!-- actions -->
    <template v-slot:page-actions>
      <CardActions
        v-if="iSEdited"
        saveBtn
        @save="toSave"
        @cancel="toBack(isChanged)"
      />
    </template>
    <!-- actions -->
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "newClaimReason",
  computed: {
    ...mapGetters(["companyLang"]),
    ClaimType() {
      return this.$getSelectTrans(this.ClaimTypeData, "claim_type_name");
    },
  },
  data() {
    return {
      iSEdited: false,
      isChanged: false,
      ClaimTypeData: [],
      ClaimReasonData: {
        claim_reason_name: "",
        sequence: 1,
        claim_reason_description: "",
        claim_reason_code: "",
        claim_type_uuid: "",
        remarks: "",
      },
    };
  },
  mounted() {
    // this.ClaimReasonData.claim_reason_name = this.$getCommonLangKey(
    //   this.companyLang
    // );
    // this.ClaimReasonData.claim_reason_description = this.$getCommonLangKey(
    //   this.companyLang
    // );
    this.getBtnPermissionList();
    this.getClaimTypes();
    this.getDetail();
  },
  methods: {
    toBack: function (change) {
      if (change)
        this.$confirmWarn(
          this.$t("message_tips"),
          this.$t("message_essweb_form_textField_refuseChange_title")
        ).then((res) => {
          if (res) {
            if (this.iSEdited) {
              this.iSEdited = false;
              this.getDetail();
            } else {
              this.$router.back();
            }
          }
        });
      else {
        if (this.iSEdited) {
          this.iSEdited = false;
          this.getDetail();
        } else {
          this.$router.back();
        }
      }
    },
    toDelete: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_clm_claim_reason",
        url: "/claim-reason/delete-claim-reason-table/",
        data: { uuids: this.$route.params.id },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_ClaimReason_list_deleteClaimReasonSuccessLabel"
          ),
          type: "success",
        });
        that.toBack();
      });
    },
    getClaimTypes: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_claim_claim_type",
        url: "/claim-type/get-claim-type-list/",
        data: {},
      }).then((res) => {
        that.ClaimTypeData = res.data;
      });
    },
    getDetail: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_clm_claim_reason",
        url: "/claim-reason/get-claim-reason-details/",
        data: {
          uuid: this.$route.params.id,
        },
      }).then((res) => {
        res.data["claim_reason_name_save"] = res.data.claim_reason_name;
        res.data.claim_reason_name = that.$transOnLineCommonLangKey(
          that.companyLang,
          res.data.claim_reason_name
        );
        res.data["claim_reason_description_save"] =
          res.data.claim_reason_description;
        res.data.claim_reason_description = that.$transOnLineCommonLangKey(
          that.companyLang,
          res.data.claim_reason_description
        );
        that.ClaimReasonData = res.data;
      });
    },
    toSave: function () {
      const that = this;
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$Request({
        method: "POST",
        table: "ess_clm_claim_reason",
        url: "/claim-reason/update-claim-reason-table/",
        data: {
          uuid: this.$route.params.id,
          claim_reason_name: this.$transCommonLangKey(
            this.ClaimReasonData.claim_reason_name,
            this.ClaimReasonData.claim_reason_name_save
          ),
          claim_reason_description: this.$transCommonLangKey(
            this.ClaimReasonData.claim_reason_description,
            this.ClaimReasonData.claim_reason_description_save
          ),
          claim_type_uuid: this.ClaimReasonData.claim_type_uuid,
          claim_reason_code: this.ClaimReasonData.claim_reason_code,
          sequence: this.ClaimReasonData.sequence,
          remarks: this.ClaimReasonData.remarks,
        },
      }).then((res) => {
        that.$showMessage({
          color: "success",
          text: that.$t(
            "message_essweb_ClaimReason_list_updateClaimReasonSuccessLabel"
          ),
          type: "success",
        });
        that.toBack(); //回到不能编辑状态
      });
    },
  },
};
</script>
